<template>
  <section>
    <div class="py-3">
      <h1 class="h1">{{ translate('lblKWSAwardCart') }}</h1>
    </div>
    <div class="bg-white py-3 px-3 mb-3"><!--'Current myKWS Seedpoint&nbspscore'-->
      <seed-point-score
        :headline="translate('lblCurrentmyKWSSeedpoints')"
        :api-url="apiUrl"
      />
    </div>
    <div v-for="(product, index) in userSelectedAwardList" :key="index" class="pb-3">
      <div class="award">
        <div class="row pt-3 px-3">
          <div class="col-12">
            <div class="text-right">
              <button class="button--link" @click="deleteProductFromSelectedAwardItems(index)">
                <span class="s s-trashcan h4"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="row p-3">
          <div class="col-12 col-m-3">
            <img v-if="product.product.teaser_image" :src="product.product.teaser_image" :alt="translate('lblProductImageAlt')"
                 class="width-inherit"/>
          </div>
          <div class="col-12  col-s-12 col-m-5 product py-3 py-m-0">
            <div class="px-2">
              <h3 class="h3" v-html="product.product.title"></h3>
              <p v-html="product.product.teaser_title"></p>
              <p v-html="product.product.teaser_text"></p>
              <a :href="productDetailUrl(product)"
                 class="link-more link-more--long">{{ translate('lblLearnMore') }}</a>
            </div>
          </div>
          <div
            class="col-12 col-s-12 col-m-4 py-3 py-m-0 d-flex flex-direction-column justify-content-flex-end">
            <div class="text-bold bg-grey p-3">
              <div  v-if="product.product.variants && product.product.variants.length > 0" class="justify-content-space-between d-flex align-items-center">
                <div class="pr-3">
                  {{ translate('lblVariants') }}
                </div>
                <select :id="product.entity_id" name="variety" v-model="product.selectedVariety"
                        class="col-s-6"
                        :class="[selectValidCheck(product.selectedVariety) ? '':' input-error ']"
                        @change="updateProductAmountInSelectedAwardItems"
                >
                  <option
                    v-for="variant in product.product.variants"
                    :key="variant.articlenumber"
                    :value="variant.articlenumber"
                    v-text="variant.title"
                  ></option>
                </select>
              </div>
              <div :class="[{'pt-3': product.product.variants && product.product.variants.length > 0}, 'justify-content-space-between d-flex align-items-center']">
                <div>{{ translate('lblQuantity') }}</div>
                <input
                  class="col-s-6"
                  type="number" v-model="product.amount" name="quantity"
                  inputMode="numeric" pattern="[1-9]*" min="1" max="999"
                  :class="[nullCheck(product.amount) ? '':'input-error']"
                  @change="updateProductAmountInSelectedAwardItems"
                />
              </div>
              <div class="pt-3 d-flex justify-content-space-between">
                <div class="word-wrap-break">{{ translate('lblPriceSingle') }}</div>
                <div class="h4 col-s-6 overflow-hidden text-right">{{ product.product.points }}</div>
              </div>

              <div class="pt-3 d-flex justify-content-space-between">
                <div class="word-wrap-break">{{ translate('lblSeedpointsNeeded') }}</div>
                <div class="h4 col-s-6 overflow-hidden text-right">{{ product.product.points * product.amount }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-flex-end">
      <div class="col-12 col-m-4 bg-white p-3 flex-direction-column d-flex">
        <div class="d-flex justify-content-space-between align-items-center pb-3">
          <div>{{ translate('lblSeedpointsRequired') }}</div>
          <div class="h3 m-0 p-0 overflow-hidden col-s-6 text-right" v-text="neededSeedPoints"></div>
        </div>
        <div v-if="!sufficientSeedpointsBalance">
          <div class="input-error error-box">{{ translate('lblInsufficientPoints') }}</div>
        </div>
        <div class="pt-3">
          <button
            class="button button--primary button--medium w-100 full-width"
            v-text="translate('lblCheckout')"
            :disabled="!sufficientSeedpointsBalance"
            @click="checkOut"
          ></button>
        </div>
      </div>
    </div>
    <div class="d-flex pt-3 pt-m-0">
      <div class="col-12 col-m-8">
        <p v-if="checkoutHint.length" v-html="checkoutHint"></p>
        <div>
          <a
            class="button button--cancel button--medium"
            v-text="translate('lblBackToShop')"
            :href="awardListUrl"
          ></a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import SeedPointScore from '@/loyalty/seed-point-score.vue';
import LoyaltyUserApiConnectorMixin from './mixins/LoyaltyApiConnectorMixin';

export default {
  name: 'AwardCheckoutCart',
  components: { SeedPointScore },
  data() {
    return {
      userSelectedAwardList: [],
      userSeedPoints: 0,
      checkForNotSetVariants: [],
    };
  },
  props: {
    translations: Object,
    checkoutFormUrl: {
      type: String,
      default: '',
    },
    awardListUrl: {
      type: String,
      default: '',
    },
    awardDetailUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    sufficientSeedpointsBalance() {
      return this.neededSeedPoints <= this.userSeedPoints;
    },
    neededSeedPoints() {
      return this.userSelectedAwardList
        .reduce((sum, item) => sum + (parseInt(item.amount, 10) * item.product.points), 0) || '---';
    },
    checkoutHint() {
      return this.translate('lblCheckoutHint');
    },
  },
  methods: {
    productDetailUrl(product) {
      let url = `${this.awardDetailUrl}?award=${product.product.entity_id}`;

      if (product.amount > 1) {
        url += `&amount=${product.amount}`;
      }

      if (product.selectedVariety !== '') {
        url += `&variant=${product.selectedVariety}`;
      }

      return url;
    },
    deleteProductFromSelectedAwardItems(index) {
      this.userSelectedAwardList = this.userSelectedAwardList.filter((value, idx) => idx !== index);
      window.sessionStorage.setItem('selectedAwardItems', JSON.stringify(this.userSelectedAwardList));
    },
    updateProductAmountInSelectedAwardItems() {
      const data = [];
      this.userSelectedAwardList.forEach((x) => {
        if (x.amount === '0' || x.amount === '') {
          data.push({
            ...x,
            amount: 1,
          });
        } else {
          data.push({
            ...x,
            amount: parseInt(x.amount, 10),
          });
        }
      });
      this.userSelectedAwardList = data;
      window.sessionStorage.setItem('selectedAwardItems', JSON.stringify(data));
    },
    nullCheck(number) {
      return number > 0;
    },
    selectValidCheck(text) {
      return text.length > 0;
    },
    checkOut() {
      const list = [];
      this.userSelectedAwardList.forEach((x) => {
        list.push({
          ...x.product,
          entity_id: x.product.entity_id,
          teaser_title: x.product.teaser_title,
          points: x.product.points,
          teaser_text: x.product.teaser_text,
          teaser_image: x.product.teaser_image,
          quantity: x.amount,
          article_number: x.selectedVariety,
        });
      });
      window.sessionStorage.setItem(
        'loyaltyCheckoutData',
        JSON.stringify({
          awards: list,
        }),
      );
      document.location.href = this.checkoutFormUrl;
    },
  },
  async created() {
    if (this.translations) {
      this.addDictionary(this.translations);
    }
    this.userSelectedAwardList = JSON.parse(sessionStorage.getItem('selectedAwardItems')) || [];
    const result = await this.getUserApiResult();
    if (result?.point_summary) {
      this.userSeedPoints = result.point_summary.point_sum;
    }
  },
  mixins: [LoyaltyUserApiConnectorMixin],
};
</script>

<style scoped>
.award {
  background-color: white;
}

.award .product {
}

.text-bold {
  font-weight: bold;
}

.input-error {
  border: red solid 2px !important;
}

.d-flex {
  display: flex;
}

.flex-direction-column {
  flex-direction: column;
}

.justify-content-space-between {
  justify-content: space-between;
}

.justify-content-flex-end {
  justify-content: flex-end;
}

.align-items-center {
  align-items: center;
}

.width-inherit {
  width: inherit;
}
.overflow-hidden {
  overflow: hidden;
}
.word-wrap-break {
  word-wrap: break-word
}
</style>
